module.exports = __webpack_public_path__ + "img/theme_switcher.f30455e5.svg";